import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=82713a1e&scoped=true&"
import script from "./FormSection.vue?vue&type=script&lang=js&"
export * from "./FormSection.vue?vue&type=script&lang=js&"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=82713a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82713a1e",
  null
  
)

export default component.exports